<template>
  <div>
    <v-row no-gutters justify="center">
      <v-col cols="1" align-self="center"> N </v-col>
    </v-row>
    <v-row no-gutters justify="center">
      <v-col cols="1" align-self="center" align="right"> W </v-col>
      <v-icon size="100" color="primary" :style="'transform: rotate(' + north_corrected + 'deg)'">
        mdi-selection-ellipse-arrow-inside
      </v-icon>
      <v-col cols="1" align-self="center" align="left"> E </v-col>
    </v-row>
    <v-row no-gutters justify="center">
      <v-col>S </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    direction: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    north_corrected() {
      return (this.direction - 135).toString()
    }

  }
};
</script>

<style></style>
